<template>
  <div class="about">
    <h1 class="page-header">Contact Us</h1>
    <div class="row justify-content-center">
      <div class="col-md-8 text-center mb-5">
        <h3>
          If you have questions regarding
          <template v-if="$store.state.country == 'us'"
            >The Ne’eman Foundation</template
          >
          <template v-else>The Emunim Fund</template>
          , please complete the form below and we'll be in touch as soon as
          possible!
        </h3>
        <h3>We are here to help!</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8"><contact-form /></div>
      <div class="col-md-4">
        <h4>Contact us by email:</h4>
        <h5 class="mt-5 mb-0 text-secondary">
          General Information and Administration
        </h5>
        <a href="mailto:info@neemanfoundation.com">info@neemanfoundation.com</a>
        <h5 class="mt-5 mb-0 text-secondary">Media, Website and Facebook</h5>
        <a href="mailto:media@neemanfoundation.com"
          >media@neemanfoundation.com</a
        >
        <h5 class="mt-5 mb-0 text-secondary">Finance and Bookkeeping</h5>
        <a href="mailto:office@neemanfoundation.com"
          >office@neemanfoundation.com</a
        >
      </div>
    </div>
    <hr class="mt-5 mb-10" />
    <h3 class="text-center mb-5">Offices:</h3>
    <div class="row">
      <div class="offset-md-2 col-md-4">
        <h5 class="text-secondary"><b>Israel Office</b></h5>
        <p class="text-secondary">
          Avnei Hachoshen 21, Shilo 4483000 Israel
          <br />
          Tel: +972-(02) 585-6616
          <br />
          Fax: +972-(02) 992-0105
          <br />
        </p>
      </div>
      <div class="col-md-4">
        <h5 class="text-secondary">
          <b>Ne'eman Foundation USA</b>
        </h5>
        <p class="text-secondary">
          867 Boylston Street<br />
          5th Floor #1342<br />
          Boston, MA 02116<br />
          Tel: 1(888) 341-8590
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import ContactForm from "../components/ContactForm";
export default {
  name: "ContactUs",
  metaInfo: {
    title: "Contact Us",
  },

  components: {
    ContactForm,
  },
};
</script>